export const performFileDownload = (url: string, fileName: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
